import { Link } from "react-router-dom";
import Logo from "../assets/img/logo.png";
import "./header.css";

const Header = () => {
  return (
    <header className="shadow-sm bg-white">
      <nav className="navbar navbar-expand-lg navbar-light container">
        <div className="container-fluid">
          {/* Logo */}
          <Link className="navbar-brand d-flex align-items-center" to="/">
            <img
              src={Logo}
              alt="MarketMind4U Logo"
              style={{ height: 70, width: "auto" }}
              className="me-2"
            />
          </Link>

          {/* Mobile toggle button */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navigation Links */}
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav mb-2 mb-lg-0 text-center">
              <li className="nav-item">
                <Link className="nav-link" to="/home">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/services">
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#projects">
                  Projects
                </a>
              </li>

              {/* Hover Dropdown */}
              <li className="nav-item dropdown">
                <span className="nav-link dropdown-hover">Pages</span>
                <ul className="dropdown-menu dropdown-hover-menu">
                  <li>
                    <Link className="dropdown-item" to="/features">
                      Features
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/ourteam">
                      Our Team
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/testominal">
                      Testimonial
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/quotation">
                      Quotation
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/pagenotfound">
                      404 Page
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
